module.exports = "/lucky-balls/img/fast-choosen-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/fast-choosen-bck.png
// module id = 160
// module chunks = 0